module.exports = __webpack_public_path__ + "static/media/screen-location-upperleft.06d58d88.svg";